import React, {FC} from 'react';
import styled from 'styled-components';

import {Skeleton, SkeletonColorSchemesEnum} from '../../skeleton';

/*
 * Style.
 */

const StyledSkeletonContainerDiv = styled.div`
  display: flex;
  flex-flow: column;
  width: 360px;
  height: 350px;
`;

const StyledHeaderDiv = styled.div`
  display: flex;
  padding: 16px;
`;

const StyledRecipientsContainerDiv = styled.div`
  display: flex;
  flex-flow: column;
  margin-left: 16px;

  & > :not(:last-child) {
    margin-bottom: 8px;
  }
`;

const StyledBodyContainerDiv = styled.div`
  border-top: 1px solid ${(p) => p.theme.alphas.black20};
  padding: 16px 16px 0 16px;
  height: 100%;
`;

export const ConversationPreviewSkeleton: FC = () => (
  <StyledSkeletonContainerDiv>
    <StyledHeaderDiv>
      <Skeleton height="30px" width="30px" scheme={SkeletonColorSchemesEnum.GREY30} borderRadius="50%" />
      <StyledRecipientsContainerDiv>
        <Skeleton height="16px" width="219px" scheme={SkeletonColorSchemesEnum.GREY30} />
        <Skeleton height="16px" width="182px" scheme={SkeletonColorSchemesEnum.GREY10} />
        <Skeleton height="16px" width="282px" scheme={SkeletonColorSchemesEnum.GREY10} />
      </StyledRecipientsContainerDiv>
    </StyledHeaderDiv>
    <StyledBodyContainerDiv>
      <Skeleton height="100%" width="328px" scheme={SkeletonColorSchemesEnum.GREY10} />
    </StyledBodyContainerDiv>
  </StyledSkeletonContainerDiv>
);
